export interface AgentInfo {
  id: number;
  name: string;
  document: string;
}
export interface DeleteRelation {
  frigId: number;
  territoryId: number;
  TokenKey: string;
}
export interface Agent {
  agents: [{
    nmAgent: string;
    vlDocument: string;
    dbOperation: string;
  }];
  requestSource: [{
    fkSystem: string;
    fkUser: string;
  }];
}
export interface Buttons {
  click: string;
  title: string;
  type: string;
}

export interface ColumnItem {
  id?: number;
  title: string;
  property: string;
  visible?: boolean;
  hasTag?: boolean;
  dontShowFilter?: boolean;
  ascOrder?: boolean;
}

export interface FilterItem {
  id: number;
  value: string;
  checked: boolean;
}

export interface Group {
  stName: string;
}

export interface MenuItem {
  component: string;
  click: string;
  title: string;
}

export interface MonitoringInfo {
  id: number;
  agents?: Array<AgentInfo>;
  type: 'Geomonitoramento' | 'Autovistoria';
  dtStart: string;
  dtEnd: string;
  status: string;
  result: string;
  visible?: boolean;
}

export interface NotificationProps {
  id: number;
  viewed: boolean;
  time: string;
  text: string;
  type: string;
}

export interface TerritoryPenaltyStatus {
  id: number;
  name: string;
}
export interface TerritoryInfo {
  agent?: string;
  agents: Array<AgentInfo>;
  city: string;
  id: number;
  name: string;
  requested: boolean;
  visible?: boolean;
  penaltyStatus: TerritoryPenaltyStatus;
}

export interface DocumentInfo {
  id: number;
  title: string;
  hasTag: boolean;
  tagTitle: string;
  type: number;
  url: string;
  status: string;
}

export interface Email {
  user: {
    email: string;
    iamkey: string;
  };
  title: string;
  attachmentUrl: string;
  body: {
    document: string;
    territory: string;
  };
}

export interface FrigInfo {
  companyName: string;
  document: string;
  email: string;
  state: string;
  city: string;
  inspectionSystem: string;
  inspectionSystemCode: string;
  password: string;
  terms: string;
}

export interface ProdInfo {
  name: string;
  document: string;
  email: string;
  phone: string;
  password: string;
  terms: string;
  lang: string;
  voucher?: string;
  address: {
    tokenKey: string;
    cdAgent: string;
    cdUser: string;
    address: string;
    number: string;
    neighborhood: string;
    complement: string;
    city: string;
    state: string;
    zipCode: string;
  };
}

export interface SelectedFilter {
  property: string;
  selected: Array<string | number | boolean | undefined>;
}

export interface ResetPassword {
  newPassword: string;
  idCrypt: string;
  stDns: string | undefined;
}

export interface RecoverPassword {
  stEmail: string;
  stDns: string | undefined;
}

export interface SetupChatBot {
  chatBotKey: string;
  chatBotUrl: string;
  skinColorHex: string;
  initialText: string;
}

// eslint-disable-next-line no-shadow
export enum StatusTerritoryAccess {
  none = 'None',
  pending = 'Pending',
  denied = 'Denied',
  granted = 'Granted',
}
export interface ResponseInfo {
  frigId: string;
  territoryId: string;
  status: StatusTerritoryAccess;
  tokenKey: string;
}

export interface CreateInfo {
  frigId: string;
  territoryId: string;
  tokenKey: string;
}

// eslint-disable-next-line no-shadow
export enum StatusTerritoryAccessNumber {
  none = 1,
  pending = 2,
  denied = 3,
  granted = 4,
}

// eslint-disable-next-line no-shadow
export enum TerritoryPenaltyStatusEnum {
  noPending = 1,
  pending = 2,
  pendingPaymentReview = 3,
}

export interface SetAsReadProps {
  userType: string;
  territoryAccessIds: number[];
}

export interface Generic {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface NotificationParams {
  type: 'Produtor' | 'Frigorifico';
  userId: number;
  tokenKey: string;
}

export interface NotificationEntity {
  id: number;
  viewed: boolean;
  time: string;
  text: string;
  type?: 'question' | 'info' | null;
  tag: string;
  url?: string;
  stCar?: string;
  dtAppointment? : string;
}

export interface OptionsQuestion {
  initChecked?: boolean;
  value: string;
}

export interface RouterProps {
  path: string;
  name: string;
}

export interface GetQuestionParams {
  evidenceId: number;
  tokenKey: string;
}

export interface GetAllQuestionParams {
  vlTitle: string;
  fkUser: number;
  dtStart: string;
  dtEnd: string;
  territory: string;
  agent: string;
  fkQuiz: number;
  status: 'pendente' | 'finalizado';
  tokenKey: string;
  fkCompany: number;
  limited: boolean;
}
export type TypeNotification = 'Produtor' | 'Frigorifico'

// eslint-disable-next-line no-shadow
export enum QuestionType {
  text = 1,
  number = 2,
  multipleChoice = 3,
  singleSelection = 4,
  onlyChoice = 5,
  photo = 8,
  date = 9,
  calc = 10,
  hour = 12,
  monetary = 13,
  email = 14,
}

export interface VoucherEntity {
  id: number;
  cdUser: number;
  voucherCode: string;
  nameProducer: string;
  activatedOn: string;
  expirationDate: string;
  status: boolean | string;
  document: string;
}

export enum PaymentMethod {
  INSTALLMENTS = 1,
  CARD = 2,
  PIX = 3
}

export interface ViolationArea {
  gid: string;
  area: string;
  detectionDate: Date;
}

export interface TerritoryViolation {
  prodes: string;
  violatedAreas: ViolationArea[];
}

export interface DueData {
  tokenKey: string;
  fkUser: string;
  cdAnalysis: string;
  cdTerritory: string;
  cdCompany: string;
  violationsToUpdate?: TerritoryViolation[];
}

export enum TicketStatus {
  PENDING = 'pending',
  PAYED = 'payed',
  CANCELLED = 'cancelled',
  LATE = 'late',
  SETTLED = 'settled'
}

export interface ActCurrent {
  act: Date;
  cdTerritory: number;
  createdOn: Date;
  dtAutorvistory: Date;
  id: number;
  status: string;
  opdatedOn: Date;
}
export interface StepDataStore {
  currentStep: number;
  address: {
    address: string;
    zipCode: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
    complement: string;
  };
  territory: {
    id: string;
    car: string;
    name: string;
    geometry: string;
    codCounty: string;
    city: string;

    representative: {
      name: string;
      document: string;
      office: string;
    };
  };
  agent: {
    id: string;
    document?: string;
  };
  img: {
    url: string;
    retry?: boolean;
    isImgHidden?: boolean;
  };
  report: { urlExtract: string };
  term: { termId: number; urlFile: string };
  penalty: { penaltyValue: number; totalInstallments: number; installments: number };
  msg?: any;
  tickets: any[];
  isErrors: boolean;
  isLoadingPayment: boolean;
  refs: { car: Vue & { reset: () => void } };
  gixUrl: string;
  paymentMethod: PaymentMethod;
}
